<template>
  <nav aria-label="Page navigation example">
    <ul class="pagination justify-content-end pagination-primary">
      <li class="page-item">
        <button
          class="page-link"
          @click="previousPage"
          :disabled="currentPage === 1"
          :class="{ disabled: currentPage === 1 }"
        >
          Anterior
        </button>
      </li>
      <li v-if="startPage > 1" class="page-item">
        <button class="page-link" @click="changePage(1)">1</button>
      </li>
      <li v-if="startPage > 2" class="page-item">
        <span class="page-link">...</span>
      </li>
      <li v-for="page in pagesToShow" :key="page" class="page-item">
        <button
          class="page-link"
          @click="changePage(page)"
          :disabled="currentPage === page"
          :class="{ active: currentPage === page }"
        >
          {{ page }}
        </button>
      </li>
      <li v-if="endPage < totalPages" class="page-item">
        <span class="page-link">...</span>
      </li>
      <li v-if="endPage < totalPages - 1" class="page-item">
        <button class="page-link" @click="changePage(totalPages)">
          {{ totalPages }}
        </button>
      </li>
      <li class="page-item">
        <button
          class="page-link"
          @click="nextPage"
          :disabled="currentPage === totalPages"
          :class="{ disabled: currentPage === totalPages }"
        >
          Siguiente
        </button>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  totalItems: {
    type: Number,
    required: true,
  },
  itemsPerPage: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["page-change"]);

const currentPage = ref(1);

const totalPages = computed(() => {
  return Math.ceil(props.totalItems / props.itemsPerPage);
});

const maxPagesToShow = 5; // Adjust this number to show more or fewer pages

const startPage = computed(() => {
  const half = Math.floor(maxPagesToShow / 2);
  if (currentPage.value <= half) {
    return 1;
  } else if (currentPage.value + half >= totalPages.value) {
    return Math.max(totalPages.value - maxPagesToShow + 1, 1);
  } else {
    return currentPage.value - half;
  }
});

const endPage = computed(() => {
  return Math.min(startPage.value + maxPagesToShow - 1, totalPages.value);
});

const pagesToShow = computed(() => {
  const pages = [];
  for (let i = startPage.value; i <= endPage.value; i++) {
    pages.push(i);
  }
  return pages;
});

const changePage = (page) => {
  currentPage.value = page;
  emit("page-change", page);
};

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
    emit("page-change", currentPage.value);
  }
};

const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
    emit("page-change", currentPage.value);
  }
};
</script>
